import { render } from "./Addemployee.vue?vue&type=template&id=394d6e96"
import script from "./Addemployee.vue?vue&type=script&lang=js"
export * from "./Addemployee.vue?vue&type=script&lang=js"

import "./Addemployee.vue?vue&type=style&index=0&id=394d6e96&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__